export default __webpack_public_path__ + "static/media/pt-br.99cc4959.svg";